module.exports = __webpack_public_path__ + "img/25_18.75341703.png";